<script>
  export let devices;
  export let camValue;
  export let micValue;
</script>

<div class="wrapper">
  <select name="cam" id="cam-select" bind:value={camValue}>
    <option value="">Please choose a webcam</option>
    {#each devices as device}
      {#if device.kind == 'videoinput'}
        <option value={device.deviceId}>{device.label}</option>
      {/if}
    {/each}
  </select>
  <select name="mic" id="mic-select" bind:value={micValue}>
    <option value="">Please choose a mic</option>
    {#each devices as device}
      {#if device.kind == 'audioinput'}
        <option value={device.deviceId}>{device.label}</option>
      {/if}
    {/each}
  </select>
</div>

<style>
  .wrapper {
    display: flex;
    flex-direction: row;
  }
  select {
    width: 50%;
    background: #253045;
    color: #fff;
    outline: none;
    border: 1px solid #33414f;
  }
  #cam-select {
    border-radius: 10px 0 0 10px;
  }
  #mic-select {
    border-radius: 0 10px 10px 0;
  }
</style>
